import { render } from "./Family.vue?vue&type=template&id=19d019f0&scoped=true"
import script from "./Family.vue?vue&type=script&lang=js"
export * from "./Family.vue?vue&type=script&lang=js"

import "./Family.vue?vue&type=style&index=0&id=19d019f0&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-19d019f0"

export default script